// src/domains/prices.keys.ts —— 模板键归属（TD-823，agent-keys 用例按片 owner 推导核对）
// 片 0087（A-10 我的售价，0045 代理加价定价）整片为 dev:A-10 偏差块
// prText：新增文案经 vals 下发（模板只直引原型 / 已登记扩展字典的 t.* 键，build split 双语守卫）
export const KEYS = ['prText', 'prUpline', 'prRows', 'prNoRows', 'prDeposit', 'prError', 'prSave'] as const;
export const MODAL_KEYS = [] as const;
